import Button, { ButtonTypes } from "../../Button";
import { ErrorWrapper } from "./styles";
import { ErrorStateProps } from "./types";

export const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => {
  return (
    <ErrorWrapper role="alert">
      <h3>Something went wrong</h3>
      <p>{message}</p>
      <Button type={ButtonTypes.primary} onClick={onRetry}>
        Try Again
      </Button>
    </ErrorWrapper>
  );
};
